module.exports = __webpack_public_path__ + "img/ic24Store.c07034ec.svg";